import { Card } from '@foodsby/nutrient'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { api } from '../api/api'
import CompleteAccount from '../components/completeAccount/CompleteAccount'
import { loadLocationStart } from '../redux/modules/location'
import { loginStart } from '../redux/modules/user'
import { friendsRoute } from '../routes/routes'
import { normalizeUserCreationError } from '../util/errorUtils'
import { pushSnowplow, toSignupProcessSchema } from '../util/snowplow'

function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

const newLocationId = getQueryVariable('newLocationId')

class PageCompleteAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      connectionId: null,
      error: false,
      errorMessage: '',
      loading: false,
      locationId: 0,
      password: '',
      passwordShowing: false,
      redirecting: false,
      submitLoading: false,
      successMessage: '',
      username: '',
    }

    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.login = this.login.bind(this)
  }

  togglePasswordVisibility() {
    this.setState(prevState => ({
      passwordShowing: !prevState.passwordShowing,
    }))
  }

  componentDidMount() {
    const {
      match: {
        params: { token },
      },
    } = this.props
    api
      .get(`/api/v1/uaa/users/inviteCode/${token}`)
      .then(data => {
        this.setState({
          connectionId: data.connectionId,
          username: data.username,
        })
        // Checks the URL if there is a new location ID, if not, it will just use the location ID from the token
        if (newLocationId) {
          this.setState({ locationId: newLocationId })
        } else {
          this.setState({ locationId: data.locationId })
        }

        this.props.loadLocationStart(this.state.locationId)
      })
      .catch(error => {
        this.setState({
          errorMessage: normalizeUserCreationError(error),
          submitLoading: false,
        })
      })
  }

  login() {
    const loginPayload = {
      connectionId: this.state.connectionId,
      password: this.state.password,
      userName: this.state.username,
    }
    this.props.loginStart(loginPayload)
  }

  handleSubmit(event) {
    this.setState({ password: event.password, submitLoading: true }, () => {
      this.login()
      const {
        match: {
          params: { token },
        },
      } = this.props
      const payload = {
        locationId: this.state.locationId,
        password: this.state.password,
      }

      api
        .put(`/api/v1/uaa/users/inviteCode/${token}/confirm`, payload)
        .then(() => {
          this.setState({
            successMessage: 'Success! Your password has been created. Logging you in...',
          })
          pushSnowplow(toSignupProcessSchema('sign_up', 'form_submit', 'success'))
          let _this = this
          setTimeout(() => {
            _this.login()
          }, 2500)
        })
        .catch(error => {
          if (error.response) {
            this.setState({
              errorMessage: normalizeUserCreationError(error.response),
              submitLoading: false,
            })
          }
        })
    })
  }

  handleChange(event) {
    this.setState({ password: event.target.value })
  }

  componentDidUpdate() {
    let { history, isAuthenticated, locationSearch } = this.props
    if (!this.state.redirecting && isAuthenticated && history) {
      this.setState({ redirecting: true }, () => {
        setTimeout(() => {
          history.push(friendsRoute.path)
        }, 1000)
      })
    }
    const {
      match: {
        params: { token },
      },
    } = this.props
    let foundLocations = locationSearch.locations.foundLocations

    if (foundLocations != null) {
      if (foundLocations.length === 1) {
        this.setState({
          locationId: foundLocations[0].id,
        })
        window.location.href = `/complete-account/${token}/?newLocationId=${foundLocations[0].id}`
      }
    }
  }

  render() {
    return (
      <div className="complete-account-article">
        <Card>
          <div className="row center-xs" style={{ marginBottom: '16px' }}>
            <h2>Complete Your Account</h2>
          </div>
          <CompleteAccount
            errorMessage={this.state.errorMessage}
            handleSubmit={this.handleSubmit}
            passwordShowing={this.state.passwordShowing}
            submitLoading={this.state.submitLoading}
            successMessage={this.state.successMessage}
            togglePasswordVisibility={this.togglePasswordVisibility}
            username={this.state.username}
          />
        </Card>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const locationSearch = state.locationSearch
  const { isAuthenticated } = state.user

  return {
    isAuthenticated,
    locationSearch,
  }
}

const mapDispatchToProps = {
  loadLocationStart,
  loginStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageCompleteAccount)
